import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    display: block;\n    ", "\n    ", "\n    transform: scale(1, .6);\n    transform-origin: 0 60%;\n\n    &:empty::before {\n        content: '\\00a0'; // no-break-space\n    }\n"], ["\n    display: block;\n    ", "\n    ", "\n    transform: scale(1, .6);\n    transform-origin: 0 60%;\n\n    &:empty::before {\n        content: '\\\\00a0'; // no-break-space\n    }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        background: linear-gradient(\n            90deg,\n            ", " 25%,\n            ", " 37%,\n            ", " 63%\n        );\n        background-size: 400% 100%;\n        animation: ", " 1.4s infinite ease;\n        border-radius: ", ";\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    0% {\n        background-position: 100% 50%;\n    }\n    100% {\n        background-position: 0 50%;\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        ", ": ", ";\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { Typography } from '../Typography';

var getDimensionFunc = function getDimensionFunc(dimension) {
  return function (props) {
    var prop = props[dimension];

    if (!prop) {
      return null;
    }

    var value = typeof prop === 'number' ? "".concat(prop, "px") : prop;
    return css(_templateObject(), dimension, value);
  };
};

var width = getDimensionFunc('width');
var height = getDimensionFunc('height');
export var skeletonAnimation = keyframes(_templateObject2());

var background = function background(_ref) {
  var gray = _ref.theme.palette.gray;
  return css(_templateObject3(), gray.gray100, gray.gray50, gray.gray100, skeletonAnimation, function (_ref2) {
    var theme = _ref2.theme;
    return theme.shape.borderRadius.medium;
  });
};

var StyledSkeleton = styled.span(_templateObject4(), width, background);
var RectSkeleton = styled.div(_templateObject5(), width, height, background);
export var Skeleton = forwardRef(function (_a, ref) {
  var _a$typographyVariant = _a.typographyVariant,
      typographyVariant = _a$typographyVariant === void 0 ? 'body1' : _a$typographyVariant,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? 'text' : _a$variant,
      height = _a.height,
      width = _a.width,
      lastLineWidth = _a.lastLineWidth,
      _a$lines = _a.lines,
      lines = _a$lines === void 0 ? 1 : _a$lines,
      props = __rest(_a, ["typographyVariant", "variant", "height", "width", "lastLineWidth", "lines"]);

  if (variant === 'rect') {
    return React.createElement(RectSkeleton, Object.assign({
      ref: ref,
      width: width,
      height: height
    }, props));
  }

  var linesRender = [];

  for (var i = 0; i < lines; i++) {
    linesRender.push(React.createElement(StyledSkeleton, Object.assign({
      key: i
    }, i === lines - 1 && lastLineWidth ? {
      width: lastLineWidth
    } : {})));
  }

  return React.createElement(Typography, Object.assign({}, props, {
    ref: ref,
    component: 'div',
    variant: typographyVariant,
    color: 'gray100'
  }), linesRender);
});
Skeleton.displayName = 'Skeleton';